import React, { useState } from 'react';
import './FilterDropdown.css'; // We'll create this CSS file

const FilterDropdown = ({ 
  title, 
  options, 
  selectedOptions, 
  onOptionChange,
  searchPlaceholder = "Search..."
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const filteredOptions = options.filter(option =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flipkart-filter-section">
      <div 
        className="filter-section-header" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{title}</span>
        <span className="dropdown-icon">{isOpen ? '−' : '+'}</span>
      </div>
      
      {isOpen && (
        <div className="filter-section-content">
          <div className="filter-search-box">
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="filter-options-list">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <label key={index} className="flipkart-filter-option">
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option)}
                    onChange={() => onOptionChange(option)}
                  />
                  <span className="checkmark"></span>
                  <span className="option-name">{option}</span>
                </label>
              ))
            ) : (
              <div className="no-options">No options found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;